import React, {Component} from 'react'
import Linkify from 'react-linkify';


const componentDecorator = (href, text, key) => (
    <a class="linkify-link" href={href} key={key} target="_blank" style={{color: 'inherit'}}>
      {text}
    </a>
  );
class Bubble extends Component {
    renderMessageImage() {
        if(this.props.currentMessage.image) {
            return (
                <div className="c-chat__image">
                    <img onClick={() => {
                        this.props.handleLightboxOpen(this.props.currentMessage.image)
                    }} src={this.props.currentMessage.image} alt=""/>
                </div>
            )
        }
        return null
    }

    render() {
        return (
            <>
                {this.renderMessageImage()}
                <div className="c-chat__message">
                    <Linkify componentDecorator={componentDecorator}>
                        {this.props.currentMessage.body}
                    </Linkify>
                                        
                </div>
                {/* {this.props.currentMessage.created_at_for_humans} */}
            </> 
        )
    }
}

export default Bubble